import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const init = async () => {
  try {    
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error(error);
  }
};

init();